import React, { useReducer } from 'react';
import { templateReducer, initialState } from '../reducers/TemplateReducer';

export const Context = React.createContext();
const TemplateProvider = (props) => {
  const [state, dispatch] = useReducer(templateReducer, initialState);

  return <Context.Provider value={{ state, dispatch }}>{props.children}</Context.Provider>;
};

export default TemplateProvider;
